import { useLoginInfo } from 'app/_hooks'
import useSWR from 'swr'
import { useAddLocaleParams } from '~/features/i18n/hooks/useAddLocaleParams'
import { useAxios } from '~/libs/axios'
import { Profile } from '~/types/api/users'
import { Video } from '~/types/api/videos'
import { WithdrawalPageResponse, WithdrawalVideos } from '~/types/api/withdrawal'

interface WithdrawalInfo {
  profile: Profile
  videos: Video[]
  reason: WithdrawalPageResponse
}

export function useWithdrawalInfo(): WithdrawalInfo | 'loading' | 'error' {
  const axios = useAxios()
  const localeParams = useAddLocaleParams()
  const loginInfo = useLoginInfo()
  const { data: profile, error: profileError } = useSWR<Profile>(
    loginInfo.status === 'signedIn' ? `/v2/user/edit?${localeParams}` : null,
    (args) => axios.get(args).then((res) => res.data),
  )
  const { data: videos, error: videosError } = useSWR<WithdrawalVideos>(
    loginInfo.status === 'signedIn' ? `/v2/videos/withdrawal_page?${localeParams}` : null,
    (args) => axios.get(args).then((res) => res.data),
  )
  const { data: reason, error: reasonError } = useSWR<WithdrawalPageResponse>(
    loginInfo.status === 'signedIn' ? `/v2/withdrawal_page?${localeParams}` : null,
    (args) => axios.get(args).then((res) => res.data),
  )

  if (profileError || videosError || reasonError) {
    return 'error'
  }

  if (profile === undefined || videos === undefined || reason === undefined) {
    return 'loading'
  }

  return {
    profile,
    videos: videos.videos,
    reason,
  }
}
